
export default {
  props: {},
  components: {},
  data: function data() {
    return {
      activeName: 'summary',
      tab: [{
        label: '总览',
        value: 'summary'
      }, {
        label: '模板使用情况',
        value: 'template'
      }, {
        label: '版本制作情况',
        value: 'version'
      }, {
        label: 'AI 服务使用情况',
        value: 'ai-usage'
      }, {
        label: '视频工具使用情况',
        value: 'veditor-usage'
      }, {
        label: '录屏工具使用情况',
        value: 'vrecord-usage'
      }, {
        label: '云剪辑',
        value: 'cloud-clip'
      }, {
        label: '订阅素材下载推送情况',
        value: 'subscription-material-push'
      }, {
        label: '定制素材下载推送情况',
        value: 'custom-material-push'
      }, {
        label: '可玩项目监控',
        value: 'playable-project'
      }, {
        label: '视频项目监控',
        value: 'video-project'
      }]
    };
  },

  methods: {
    handleClick: function handleClick() {
      this.$router.push({
        path: '/dashboard/pt-user-dashboard/' + this.activeName
      });
    },
    getTabNameByPath: function getTabNameByPath(path) {
      // path 结构为dashboard.pt-user-dashboard.{tabName}
      return path.split('.')[2];
    }
  },
  computed: {
    innerTab: function innerTab() {
      if (this.$route.query.token) {
        return [this.tab[1]];
      }
      return this.tab;
    }
  },
  watch: {
    $route: function $route(to, from) {
      this.activeName = this.getTabNameByPath(this.$route.name);
    }
  },
  mounted: function mounted() {
    this.activeName = this.getTabNameByPath(this.$route.name);
  }
};